export default __webpack_public_path__ + "static/hero-desktop-1075a9b8fb5438cf8849e919a54afe90.png";